module.exports = __webpack_public_path__ + "74a4911700b0c6d2aa59a0eaefd79ecc.MP3";